Array.prototype.clean = ((deleteValue = '') ->
    for value, i in this
        if value is deleteValue
            this.splice(i, 1)
            i--
    return this
)